/**
 * SharedLohnverrechnungTabs — Navigation tabs for Lohnverrechnung sub-pages.
 * Renders a sticky sub-header with tab bar at the top of each Lohnverrechnung view.
 *
 * Sticky sub-header (#720):
 * - Wrapper breaks out of parent `p-6` via `-mx-6 -mt-6`, adds own `px-6 py-3`
 * - `sticky top-0` sticks to top of <main>'s scroll container
 *
 * @since v2.305.1 (sticky sub-header since v2.310.5)
 */
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const TABS = [
  { key: 'archiv', path: '/lohnverrechnung', labelKey: 'nav.lohnverrechnung.archiv' },
  { key: 'import', path: '/lohnverrechnung/import', labelKey: 'nav.lohnverrechnung.import' },
  { key: 'monats-bestaetigung', path: '/lohnverrechnung/monats-bestaetigung', labelKey: 'nav.lohnverrechnung.monatsBestaetigung' },
  { key: 'lv-report', path: '/lohnverrechnung/lv-report', labelKey: 'nav.lohnverrechnung.lvReport' },
  { key: 'einstellungen', path: '/lohnverrechnung/einstellungen', labelKey: 'nav.lohnverrechnung.einstellungen' },
];

export default function SharedLohnverrechnungTabs() {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-30 -mx-6 -mt-6 mb-5 bg-[var(--bg-primary,#F4F5FA)] border-b border-[var(--border-default,#E5E7EB)] px-6 py-3">
      <div className="bg-[var(--bg-inset,#F8F9FC)] rounded-[10px] p-[3px] border border-[var(--border-default,#E5E7EB)] inline-flex gap-1 flex-wrap">
        {TABS.map(tab => {
          const isActive = location.pathname === tab.path;
          return (
            <button
              key={tab.key}
              onClick={() => navigate(tab.path)}
              className={`px-4 py-2 rounded-[10px] text-sm font-medium transition-all whitespace-nowrap ${
                isActive
                  ? 'bg-white shadow-sm text-[var(--text-primary)] font-semibold dark:bg-[var(--bg-card)]'
                  : 'text-[var(--text-secondary)] hover:text-[var(--text-primary)]'
              }`}
            >
              {t(tab.labelKey)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
